// extracted by mini-css-extract-plugin
export default {"tableBox":"TableBox_tableBox__AqBWn","enTableBox":"TableBox_enTableBox__H6quV","ruTableBox":"TableBox_ruTableBox__k1C5h"};